import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";

export function fieldHintId(controlId: string): string {
  return `${controlId}-hint`;
}

export interface FieldHintProps extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode;
}

export function FieldHint({
  id,
  className,
  children,
  ...props
}: FieldHintProps) {
  return (
    <p
      id={id}
      className={cn("mt-1.5 text-sm text-surface-500", className)}
      {...props}
    >
      {children}
    </p>
  );
}
